import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DashboardComponent } from './feature/dashboard/dashboard.component';
import { AuthReturnComponent } from './feature/auth-return/auth-return.component';
import { MapsComponent } from './feature/maps/maps.component';
import { ResolutionComponent } from './feature/resolution/resolution.component';
import { SurveyBacklogComponent } from './feature/survey-backlog/survey-backlog.component';
import { UnauthorizedComponent } from './feature/unauthorized/unauthorized.component';
import { LoginComponent } from './feature/login/login.component';
import { AuthGuard } from './core/guards/auth.guard';
import { NoAccessComponent } from './feature/no-access/no-access.component';
import {
  ADMIN_ROUTE,
  ASSETS_ROUTE,
  AUTHRETURN_ROUTE,
  COMPLIANCE_ROUTE,
  DASHBOARD_ROUTE,
  FORBIDDEN_ROUTE,
  FULLACCESS,
  LOGIN_ROUTE,
  MAP_ROUTE,
  MOBILTEX_MEMBER_ROUTE,
  MOBILTEX_MEMBER_SCREEN,
  NOACCESS_ROUTE,
  READACCESS,
  REPORTS_ROUTE,
  RESOLUTION_ROUTE,
  SETUP_ROUTE,
  SURVEY_BACKLOG_ROUTE,
  SURVEY_ROUTE,
  UNAUTHORIZED_ROUTE,
} from './shared/constants';
import { MTXMemberOverviewComponent } from './feature/mtx-member-overview/mtx-member-overview.component';
import { UnauthorizedGuard } from './core/guards/unauthorized.guard';

const routes: Routes = [
  {
    path: '',
    redirectTo: DASHBOARD_ROUTE,
    pathMatch: 'full',
    data: {
      breadcrumb: 'Dashboard',
      title: 'Dashboard',
      screen: 'Dashboard',
      requiredPermission: [READACCESS, FULLACCESS],
    },
    canActivate: [AuthGuard],
  },
  {
    path: DASHBOARD_ROUTE,
    component: DashboardComponent,
    data: {
      breadcrumb: 'Dashboard',
      title: 'Dashboard',
      screen: 'Dashboard',
      requiredPermission: [READACCESS, FULLACCESS],
    },
    canActivate: [AuthGuard],
  },
  {
    path: MAP_ROUTE,
    component: MapsComponent,
    data: {
      breadcrumb: 'Map',
      title: 'Map',
      screen: 'Map',
      requiredPermission: [READACCESS, FULLACCESS],
    },
    canActivate: [AuthGuard],
  },
  {
    path: FORBIDDEN_ROUTE,
    component: UnauthorizedComponent,
    canActivate: [UnauthorizedGuard],
  },
  {
    path: UNAUTHORIZED_ROUTE,
    component: UnauthorizedComponent,
    canActivate: [UnauthorizedGuard],
  },
  { path: AUTHRETURN_ROUTE, component: AuthReturnComponent },
  // Unguarded on purpose: this is the entry point for unauthenticated users.
  // LoginComponent self-hydrates and routes an already-signed-in user into the app.
  { path: LOGIN_ROUTE, component: LoginComponent },
  { path: NOACCESS_ROUTE, component: NoAccessComponent },
  {
    path: COMPLIANCE_ROUTE,
    data: { breadcrumb: 'Compliance' },
    loadChildren: () =>
      import('./routes/compliance.module').then((m) => m.ComplianceModule),
    canActivate: [AuthGuard],
  },
  {
    path: REPORTS_ROUTE,
    data: { breadcrumb: 'Reports' },
    loadChildren: () =>
      import('./routes/reports.module').then((m) => m.ReportsModule),
    canActivate: [AuthGuard],
  },
  {
    path: ADMIN_ROUTE,
    data: { breadcrumb: 'Admin' },
    loadChildren: () =>
      import('./routes/admin.module').then((m) => m.AdminModule),
    canActivate: [AuthGuard],
  },
  {
    path: ASSETS_ROUTE,
    data: { breadcrumb: 'Assets' },
    loadChildren: () =>
      import('./routes/assets.module').then((m) => m.AssetsModule),
    canActivate: [AuthGuard],
  },
  {
    path: SURVEY_ROUTE,
    data: { breadcrumb: 'Surveys' },
    loadChildren: () =>
      import('./routes/survey.module').then((m) => m.SurveyModule),
    canActivate: [AuthGuard],
  },
  {
    path: SURVEY_BACKLOG_ROUTE,
    component: SurveyBacklogComponent,
    canActivate: [AuthGuard],
  },
  {
    path: RESOLUTION_ROUTE,
    component: ResolutionComponent,
    canActivate: [AuthGuard],
  },
  {
    path: SETUP_ROUTE,
    data: { breadcrumb: 'Setup' },
    loadChildren: () =>
      import('./routes/setup.module').then((m) => m.SetupModule),
    canActivate: [AuthGuard], //verify with harmeet
  },
  {
    path: MOBILTEX_MEMBER_ROUTE,
    data: {
      breadcrumb: 'Mobiltex Member',
      title: 'Mobiltex Member Overview',
      screen: MOBILTEX_MEMBER_SCREEN,
      requiredPermission: [FULLACCESS, READACCESS],
    },
    component: MTXMemberOverviewComponent,
    canActivate: [AuthGuard],
  },
  {
    path: MOBILTEX_MEMBER_ROUTE,
    data: { breadcrumb: 'Setup' },
    loadChildren: () =>
      import('./routes/mobiltexMembers.module').then(
        (m) => m.MobiltexMembersModule,
      ),
    canActivate: [AuthGuard],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
